import { winBiddingOperateColumn } from './ExportWinBiddingOperate';
import { winTransferCarColumn } from './ExportTransferCar';
import { waitPayCarColumn } from './ExportWaitPayCar';
import { waitSignContractColumn } from './ExportWaitSignContract';
/**
 * @param props
 * {
 *    pageIdentification: 页面标示
 *    orderCallback: () => {} 回调函数
 *    record: 当前操作记录的信息
 * }
 */
export function useOperate(props) {
    const { pageIdentification, record, orderCallback } = props;
    switch (pageIdentification) {
        case 'winBiddingcar': // 中标
            return winBiddingOperateColumn({
                pageIdentification,
                orderCallback,
                record
            });
        case 'waitTransfer': // 交付中
            return winTransferCarColumn({
                pageIdentification,
                orderCallback,
                record
            });
        case 'waitSignContract': // 待签署合同
            return waitSignContractColumn({
                pageIdentification,
                orderCallback,
                record
            });
        case 'waitPayCar': // 待付款
            return waitPayCarColumn({
                pageIdentification,
                orderCallback,
                record
            });
    }
}
